import { adData, variousURLs, tokenName, recaptchaScriptSrc, userRoles } from "../config";
import { getString, isLoggedInWithRole, isLoggedInWithoutRole } from "./";

let abcyaLoadAdScriptsInit = false;

export const loadReCaptchaScript = () => {
  if (!window.grecaptcha) {
    const appHead = document.getElementsByTagName("head")[0];
    const recaptchaScript = document.createElement("script");

    recaptchaScript.src = recaptchaScriptSrc;
    appHead.appendChild(recaptchaScript);
  }
};

export const loadPrerollVideoDependencies = () => {
  if (!window.ima) {
    const appHead = document.getElementsByTagName("head")[0];

    const styles = [
      "https://vjs.zencdn.net/7.11.4/video-js.css",
      "https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-ads/6.7.0/videojs.ads.css",
      "https://cdnjs.cloudflare.com/ajax/libs/videojs-ima/1.10.1/videojs.ima.css",
    ];

    const sources = [
      "https://imasdk.googleapis.com/js/sdkloader/ima3.js",
      "https://vjs.zencdn.net/7.11.4/video.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/videojs-ima/1.10.1/videojs.ima.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/videojs-contrib-ads/6.0.0/videojs.ads.min.js",
      "/static/ovp.js",
    ];

    let styleIndex = 0;
    let sourceIndex = 0;
    // Recursively load styles and scripts on load.
    const loadAdPlayerDeps = () => {
      if (styleIndex < styles.length) {
        const styleSheet = document.createElement("link");
        const style = styles[styleIndex];
        styleSheet.setAttribute("rel", "stylesheet");
        styleSheet.setAttribute("type", "text/css");
        styleSheet.setAttribute("href", style);
        styleSheet.onload = loadAdPlayerDeps;
        ++styleIndex;
        appHead.appendChild(styleSheet);
      } else if (sourceIndex < sources.length) {
        const script = document.createElement("script");
        const source = sources[sourceIndex];
        script.src = source;
        script.async = false;
        script.onload = loadAdPlayerDeps;
        ++sourceIndex;
        appHead.appendChild(script);
      }
    };

    loadAdPlayerDeps();
  }
};

export const getSchema = (schema) => {
  const keywords = Array.isArray(schema.keywords) ? schema.keywords.join(", ") : schema.keywords;

  const innerHTML = {
    "@context": variousURLs.schema,
    "@type": schema.type,
    url: `${variousURLs.abcya}${schema.url}`,
    name: schema.name,
    description: schema.description,
    keywords,
    alternateName: getString("head.defaultTitle"),
    logo: variousURLs.logo,
    sameAs: [variousURLs.facebook, variousURLs.twitter, variousURLs.instagram, variousURLs.vimeo],
  };

  if (schema.uploadDate && schema.uploadDate.length > 0) {
    innerHTML.uploadDate = schema.uploadDate;
  }

  if (schema.thumbnailUrl && schema.thumbnailUrl.length > 0) {
    innerHTML.thumbnailUrl = [schema.thumbnailUrl];
  }

  const ss = {
    type: "application/ld+json",
    innerHTML: JSON.stringify(innerHTML),
  };
  return [ss];
};

export const getMeta = (metas) => {
  return metas.map((item) => {
    const itemKeys = Object.keys(item);

    const meta = {};

    itemKeys.forEach((prop) => {
      if (prop === "content") {
        meta.content = Array.isArray(item.content) ? item.content.join(", ") : item.content;
      } else {
        meta[prop] = item[prop];
      }
    });

    return meta;
  });
};

const loadAdScripts = (adScriptsReady) => {
  if (!adScriptsReady && !abcyaLoadAdScriptsInit) {
    abcyaLoadAdScriptsInit = true;
    let scriptsCounter = 0;
    const appHead = document.getElementsByTagName("head")[0];

    const loadScript = () => {
      const adScript = adData.headScripts[scriptsCounter];
      const headScript = document.createElement("script");

      if (adScript.type) {
        headScript.type = adScript.type;
      }

      headScript.async = false;
      headScript.src = adScript.src;

      if (scriptsCounter++ < adData.headScripts.length - 1) {
        headScript.onload = loadScript;
      }

      const scpt = appHead.appendChild(headScript);
    };

    loadScript();
  }
};

export const handleAdScriptsLoading = () => {
  const adScriptsReady = Object.prototype.hasOwnProperty.call(window, "gAllSlotData");

  if ((!window.localStorage.getItem(tokenName) || isLoggedInWithRole(userRoles.free)) && !adScriptsReady) {
    // no token present, always loads ad scripts
    loadAdScripts(adScriptsReady);
  } else if (adScriptsReady && isLoggedInWithoutRole(userRoles.free)) {
    window.location.reload();
  }
};

export const refreshAds = async (adIdArray) => {
  // buffer to hopefully allow ad engine script to load
  const numOfTries = 10;
  let retryCounter = 0;

  const refreshFunction = () => {
    if (window.amp_refreshSlots && typeof window.amp_refreshSlots === "function") {
      window.amp_refreshSlots(adIdArray);
    } else if (retryCounter <= numOfTries) {
      setTimeout(
        () => {
          retryCounter++;
          refreshFunction();
        },
        !retryCounter ? 0 : 500,
      );
    }
  };

  refreshFunction();
};
